import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage, defineMessages } from 'react-intl';
import './styles.css';
import Header from '../../components/Header';
import Checkbox from '../../components/Checkbox';
import Button from '../../components/Button';
import Divider from '../../components/Divider';
import Toast from '../../components/Toast';
import PageTitle from '../../components/PageTitle';

const messages = defineMessages({
  YourNotifications: {
    id: 'settings.your-notifications.pageTitle',
    defaultMessage: 'Your Notifications',
  },
  pageInstructions: {
    id: 'settings.your-notifications.pageInstructions',
    defaultMessage: 'Choose what you\'d like to receive email notifications about.',
  },
  repVisitsHeading: {
    id: 'settings.your-notifications.repVisitsHeading',
    defaultMessage: 'REPVISITS',
  },
  buttonSave: {
    id: 'settings.your-notifications.buttonSave',
    defaultMessage: 'Save',
  },
  changeSuccess: {
    id: 'settings.your-notifications.changeSuccess',
    defaultMessage: 'Your notifications settings were updated.',
  },
  failureDescription: {
    id: 'settings.your-notifications.failureDescription',
    defaultMessage: 'Something unexpected happened. Please try your request again.',
  },
  optOutAvailabilityEmailsDescription: {
    id: 'settings.your-notifications.optOutAvailabilityEmailsDescription',
    defaultMessage: 'Alert me when high schools become available in RepVisits',
  },
});

class YourNotifications extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    checked: PropTypes.bool,
    updateUserSettings: PropTypes.func.isRequired,
  };

  state = {
    success: false,
    saveError: false,
    checked: !this.props.viewer.userSettings.repVisits.hasOptedOutOfAvailabilityEmails,
  };

  submit = () => {
    this.props.updateUserSettings({
      variables: {
        input: {
          hasOptedOutOfAvailabilityEmails: !this.state.checked,
        },
      },
    }).then(() => {
      this.setState({ success: true, saveError: false });
    }).catch(() => {
      this.setState({ success: false, saveError: true });
    });
  };

  hideSuccessMessage = () => {
    this.setState({ success: false });
  };

  selection = () => {
    this.setState((prevState) => ({ checked: !prevState.checked }));
  };

  render() {
    const { success, saveError, checked } = this.state;
    return (
      <div styleName="notifications-body">
        <PageTitle subTitle="Your notifications" title="Settings" category="Intersect" />
        <Header as="h2" styleName="pageHeader" id="right-side-heading">
          <FormattedMessage {...messages.YourNotifications} />
        </Header>
        <p><FormattedMessage {...messages.pageInstructions} /> </p>
        <Header as="h3" styleName="form-section-heading">
          <FormattedMessage {...messages.repVisitsHeading} />
        </Header>
        <Checkbox
          id="opt_out_availability_emails"
          name="chk_opt_out_availability_emails"
          onChange={this.selection}
          aria-label={messages.adviseStudents}
          checked={checked}
          label={{
            htmlFor: 'opt_out_availability_emails',
            children: (<FormattedMessage {...messages.optOutAvailabilityEmailsDescription} />),
          }}
        />

        <div styleName="empty-area" />
        <Divider />
        <div styleName="button-section">
          <Button primary onClick={this.submit} data-cy="your-notifications-save-button">
            <FormattedMessage {...messages.buttonSave} />
          </Button>
        </div>
        <Toast
          active={success}
          description={<FormattedMessage {...messages.changeSuccess} />}
          onDeactivate={this.hideSuccessMessage}
        />
        <Toast
          active={saveError}
          description={<FormattedMessage {...messages.failureDescription} />}
          kind="error"
          onDeactivate={this.hideFailureMessage}
        />
      </div>
    );
  }
}

export default YourNotifications;
